import { setupCalendar } from 'v-calendar';
import Vue3Linkify from 'vue-3-linkify';

export default defineNuxtPlugin(({ vueApp }) => {
  vueApp.use(setupCalendar, {});
  vueApp.use(Vue3Linkify);
});
